<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hPEgc9/tc-custom/9780795351914.jpg?1705291436620" alt="This image is the cover for the book Princess and Curdie, The Cullen Collection"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Princess and Curdie, The Cullen Collection
      </h1>
      <p class="bookDescription body article font2">
        <b>The Victorian-era fairy tale and sequel to <i>The Princess and the Goblin</i> from the Scottish author who influenced C.S. Lewis. </b><br/>  <br/> This second “Curdie” installment, published in 1882, is far more than a mere “children’s story.” The themes and linguistic style of <i>The Princess and Curdie</i> are considerably more advanced, and the depth of its spiritual analogies extensive in subtlety and scope. After being thrust into the rose-fire, the discerning gift of Curdie’s hand to know toward what any man or woman is growing (beast or child), is one of MacDonald’s most memorable, though chilling, images. It is a theme that became profoundly illuminated in later years by MacDonald’s spiritual protégé C.S. Lewis, when he wrote in <i>Mere Christianity</i>, “Every time you make a choice you are turning the central part of you, the part of you that chooses, into something a little different from what it was before. And taking your life as a whole, with all your innumerable choices, all your life long you are slowly turning this central thing either into a heavenly creature or a hellish creature.” Lewis’s words embody a truth that emerges directly out of Curdie’s story. This edition for The Cullen Collection is unedited in any way.<br/>  <br/><b>Praise for <i>The Princess and the Goblin</i> and <i>The Princess and Curdie</i></b><br/>  <br/> “<i>The Princess and the Goblin</i> and <i>The Princess and Curdie</i> are two of the most unusual and haunting fairy tales ever written.”<i>—The Guardian</i><br/>  <br/> “Absorbing stories, a rich feast for the imagination also intended to nourish the souls and intellects of the hearers.”—<i>Vintage Novels</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George MacDonald, Michael Phillips
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e6d6802